import { render } from "./index.vue?vue&type=template&id=318e00de"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=318e00de&lang=scss"
script.render = render

export default script